export default "__VITE_ASSET__CBb7dhCC__"